/**
 * The "is one of" operator. Handled specially in buildFilterElement (expands to OR groups),
 * but also present in POSITIVE_TO_NEGATION_MAP so "is not one of" can be derived from it.
 */
export const IS_ONE_OF_OPERATOR = "is one of" as const;

/**
 * Maps positive operators (space-separated, as stored in the API) to their negating
 * counterparts. Negation in the GraphQL schema is expressed via FilterBooleanOperator.NOT
 * wrapping since negating variants don't exist directly in the schema.
 *
 * This is the source of truth. NEGATION_TO_POSITIVE_MAP is derived from this.
 */
export const POSITIVE_TO_NEGATION_MAP: Record<string, string> = {
  // "is one of" is handled specially in buildFilterElement (expands to OR groups),
  // but the map entry is used when building "is not one of" via NEGATION_TO_POSITIVE_MAP.
  [IS_ONE_OF_OPERATOR]: "is not one of",
  equals: "does not equal",
  contains: "does not contain",
  is: "is not",
  // Note: "starts-with" and "ends-with" are intentionally excluded — the UX designs
  // don't include negating variants for these operators.
};

/**
 * Inverse of POSITIVE_TO_NEGATION_MAP: maps negating operators to their positive
 * counterparts. Derived automatically to stay in sync with POSITIVE_TO_NEGATION_MAP.
 */
export const NEGATION_TO_POSITIVE_MAP: Record<string, string> =
  Object.fromEntries(
    Object.entries(POSITIVE_TO_NEGATION_MAP).map(([positive, negating]) => [
      negating,
      positive,
    ]),
  );
